//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Base from './rb-base.vue'
export default {
  name: 'rb-checkbox',
  extends: Base,
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    desc: {
      type: String,
    },
    title: {
      type: String,
    },
    checkboxValue: {
      type: String,
    },
  },
}
